import {getResults, getOATResults, getAcademicAverage, getOATAcademicAverage} from '@bootcamp/shared/src/util/scoring';


export function getAnalysis(title, scoring) {
  const subject = title.match(/([^#]+)( Test)/)[1];
  const percentage = (scoring.overview.score / scoring.overview.maxScore) * 100;
  const avgPercentage = (scoring.overview.avgScore / scoring.overview.maxScore) * 100;
  const {score, analysis} = getResults(percentage, title, subject);
  const {score: avgScore} = getResults(avgPercentage, title, subject);

  return {
    feedback: (
      <span>
        {analysis}<br /><br />
        Based on your results, I'd <strong>estimate a DAT {subject} score of {score}</strong>. Don't focus too much on the estimate - instead, continue to review your areas of knowledge.
        <br />
        <br />
        Starting March 1, 2025, the DAT switched to a 3-digit scoring scale (200-600). <a href="https://bootcamp.com/blog/upcoming-changes-to-dat-scoring-and-reporting-march-1-2025" target="_blank">Learn more here.</a>
      </span>
    ),
    score,
    avgScore,
    subject
  }
}

export function getOATAnalysis(title, scoring) {
  const subject = title.match(/([^#]+)( Test)/)[1];
  const percentage = (scoring.overview.score / scoring.overview.maxScore) * 100;
  const avgPercentage = (scoring.overview.avgScore / scoring.overview.maxScore) * 100;
  const score = getOATResults(percentage, title, subject);
  const avgScore = getOATResults(avgPercentage, title, subject);

  return {
    feedback: (
      <span>
        Based on your results, I'd <strong>estimate a OAT {subject} score of {score}</strong>. Don't focus too much on the estimate - instead, continue to review your areas of knowledge.
      </span>
    ),
    score,
    avgScore,
    subject
  }
}
// this translates our new scoring object into something the old scoring
// helpers can understand
function formatFullLengthStatistics(scoring, useAvg=false, title, bootcamp='dat') {
  try {
    const snsSubjects = ['Biology', 'General Chemistry', 'Organic Chemistry'];
    const subjects = scoring?.subjectBreakdown;
    const testNumber = title?.match(/#(.*)/)?.[1];
    const nonSNSSubjects = Object
      .keys(subjects)
      .filter(subject => !snsSubjects.includes(subject));

    const formatSubject = (name, subject) => {
      const subjectTestName = `${name} Test #${testNumber}`;
      const percentage = (subject.score / subject.maxScore) * 100;
      const score = bootcamp === 'dat'
        ? getResults(percentage, subjectTestName, name).score
        : getOATResults(percentage, subjectTestName, name);

      return {
        name,
        subjectTestName: subjectTestName,
        total: subject.maxScore,
        correct: useAvg ? subject.avgScore : subject.score,
        score,
      }
    }

    const groups = [
      {
        name: 'Survey of Natural Sciences',
        subjectStatistics: snsSubjects.map(subject => formatSubject(subject, subjects[subject]))
      },
      ...nonSNSSubjects.map(subject => ({
        name: subject,
        subjectStatistics: [
          formatSubject(subject, subjects[subject]),
        ]
      }))
    ];

    return groups;
  } catch (error) {
    console.log('error formatting', error);
    return [];
  }
}
export function getFullLengthAnalysis(title, scoring) {
  const formattedStatistics = formatFullLengthStatistics(scoring, false, title, 'dat');
  const formattedStatisticsAvg = formatFullLengthStatistics(scoring, true, '', 'dat');
  const subjectStatistics = formattedStatistics.reduce((acc, statistic) => [...acc, ...statistic.subjectStatistics], []);

  const academicAverage = getAcademicAverage(title, formattedStatistics);
  const avgAcademicAverage = getAcademicAverage(title, formattedStatisticsAvg);

  return {
    feedback: (
      <span>Based on your results, I'd <strong>estimate an AA score of {academicAverage}</strong>. Don't focus too much on the estimate - instead, continue to review your areas of knowledge.
        <br />
        <br />
        Starting March 1, 2025, the DAT switched to a 3-digit scoring scale (200-600). <a href="https://bootcamp.com/blog/upcoming-changes-to-dat-scoring-and-reporting-march-1-2025" target="_blank">Learn more here.</a>
      </span>
    ),
    score: academicAverage,
    avgScore: avgAcademicAverage,
    subjectStatistics
  }
}

export function getOATFullLengthAnalysis(title, scoring) {
  const formattedStatistics = formatFullLengthStatistics(scoring, false, title, 'oat');
  const formattedStatisticsAvg = formatFullLengthStatistics(scoring, true, title, 'oat');
  const subjectStatistics = formattedStatistics.reduce((acc, statistic) => [...acc, ...statistic.subjectStatistics], []);


  const academicAverage = getOATAcademicAverage(title, formattedStatistics);
  const avgAcademicAverage = getOATAcademicAverage(title, formattedStatisticsAvg);

  return {
    feedback: (
      <span>Based on your results, I'd <strong>estimate an AA score of {academicAverage}</strong>. Don't focus too much on the estimate - instead, continue to review your areas of knowledge.</span>
    ),
    score: academicAverage,
    avgScore: avgAcademicAverage,
    subjectStatistics
  }
}

// export function getSnsChartData(bio, gc, oc) {
//   const bioTime = getInObj(['result', 0, 'questions'], bio, []).reduce((acc, {time}) => acc + parseFloat(time), 0);
//   const gcTime = getInObj(['result', 0, 'questions'], gc, []).reduce((acc, {time}) => acc + parseFloat(time), 0);
//   const ocTime = getInObj(['result', 0, 'questions'], oc, []).reduce((acc, {time}) => acc + parseFloat(time), 0);

//   return [
//     ['Subject', 'Time'],
//     [`Biology ${moment.utc(bioTime * 1000).format('HH:mm:ss')}`, bioTime],
//     [`General Chemistry ${moment.utc(gcTime * 1000).format('HH:mm:ss')}`, gcTime],
//     [`Organic Chemistry ${moment.utc(ocTime * 1000).format('HH:mm:ss')}`, ocTime]
//   ]
// }

// export function getTopicChartData(statistics) {
//   return [
//     ['Time Spent', 'Topic'],
//     ...statistics.map(({name, timeSpent}) => [`${name} ${moment.utc(timeSpent * 1000).format('HH:mm:ss')}`, timeSpent])
//   ];
// }